const activationSelector = 'button[on\\:click], summary[on\\:click], [role="button"][on\\:click]';
const activationKeys = new Set(['Enter', ' ']);

document.addEventListener(
  'keydown',
  (event) => {
    if (event.defaultPrevented || event.repeat || !activationKeys.has(event.key)) return;

    const target = event.target instanceof Element ? event.target.closest(activationSelector) : null;
    if (!target) return;
    if (target.matches(':disabled, [aria-disabled="true"]')) return;

    event.preventDefault();
    target.click();
  },
  true
);
